export default {
    table: {
        border: true,
        fit: true,
        align: "left",
        headerAlign: "left",
        footerAlign: "left",
        showHeader: true,
        animat: true,
        delayHover: 250,
        autoResize: true,
        minHeight: null,
        maxHeight: null,
        keepSource: false,
        showOverflow: false,
        showHeaderOverflow: false,
        showFooterOverflow: true,
        // size: null,
        // zIndex: null,
        stripe: false,
        // round: false,
        // emptyText: '暂无数据',
        // emptyRender: {
        //   name: ''
        // },
        loadingConfig: { icon: "el-icon-loading", text: "加载中..." }, // 修改加载中图标
        rowConfig: {
            // keyField: '_X_ROW_KEY', // 行数据的唯一主键字段名
            // 是否需要为每一行的 VNode 设置 key 属性
            boolean: false,
            // 自定义行数据唯一主键的字段名（默认自动生成）
            // 当鼠标点击行时，是否要高亮当前行
            isCurrent: false,
            // 当鼠标移到行时，是否要高亮当前行
            isHover: true,
        },
        columnConfig: {
            resizable: true,
        },
        resizeConfig: {
            refreshDelay: 250,
        },
        radioConfig: {
            // trigger: 'default'
            strict: true,
        },
        checkboxConfig: {
            // trigger: 'default',
            strict: true,
            checkField: 'isChecked', // 绑定选中属性（行数据中必须存在该字段，否则无效)
            indeterminateField: "isIndeterminate", // 绑定半选属性（行数据中必须存在该字段，否则无效）
        },
        tooltipConfig: {
            // 所有单元格开启工具提示 boolean
            showAll: false,
            // tooltip 的主题颜色string  dark,light
            theme: "dark",
            // 鼠标是否可进入到工具提示中boolean
            enterable: false,
            // 鼠标移入后延时多少才显示工具提示number
            enterDelay: 500,
            // 鼠标移出后延时多少才隐藏工具提示number
            leaveDelay: 300,
        },
        validConfig: {
            showMessage: true,
            autoClear: true,
            autoPos: true,
            message: "inline",
            msgMode: "single",
        },
        menuConfig: {
            enabled: false, // 是否启用
        },
        customConfig: {
            allowVisible: true,
            allowResizable: true,
            allowFixed: true,
            allowSort: true,
            showFooter: true,
            placement: "topRight",
            //  storage: false,
            //  checkMethod () {},
            modalOptions: {
                showZoom: true,
                mask: true,
                lockView: true,
                resize: true,
                escClosable: true,
            },
        },
        sortConfig: {
            // remote: false,
            // trigger: 'default',
            // orders: ['asc', 'desc', null],
            // sortMethod: null,
            showIcon: true,
            iconLayout: "vertical",
        },
        filterConfig: {
            // remote: false,
            // filterMethod: null,
            showIcon: true,
        },
        treeConfig: {
            rowField: "id",
            parentField: "parentId",
            childrenField: "children",
            hasChildField: "hasChild",
            mapChildrenField: "_X_ROW_CHILD",
            indent: 20,
            showIcon: true,
        },
        expandConfig: {
            // trigger: 'default',
            showIcon: true,
        },
        editConfig: {
            // mode: 'cell',
            showIcon: true,
            showAsterisk: true,
        },
        importConfig: {
            _typeMaps: {
                csv: 1,
                html: 1,
                xml: 1,
                txt: 1,
            },
            modes: ["insert", "covering"],
        },
        exportConfig: {
            _typeMaps: {
                csv: 1,
                html: 1,
                xml: 1,
                txt: 1,
            },
            modes: ["current", "selected"],
        },
        printConfig: {
            modes: ["current", "selected"],
        },
        mouseConfig: {
            extension: true,
        },
        keyboardConfig: {
            isEsc: true,
        },
        scrollX: {
            // enabled: false,
            gt: 60,
            // oSize: 0
        },
        scrollY: {
            // enabled: false,
            gt: 100,
            // oSize: 0
        },
    },
    export: {
        types: {},
    },

    grid: {
        // size: null,
        // zoomConfig: {
        //   escRestore: true
        // },
        formConfig: {
            enabled: true,
        },
        pagerConfig: {
            enabled: true,
            // perfect: false
        },
        toolbarConfig: {
            enabled: true,
            // perfect: false
        },
        proxyConfig: {
            enabled: true,
            autoLoad: true,
            message: true,
            props: {
                list: null,
                result: "result",
                total: "page.total",
                message: "message",
            },
            // beforeItem: null,
            // beforeColumn: null,
            // beforeQuery: null,
            // afterQuery: null,
            // beforeDelete: null,
            // afterDelete: null,
            // beforeSave: null,
            // afterSave: null
        },
    },
    pager: {

    },
};
